module.exports = __webpack_public_path__ + "static/media/anounceWithUsDesktop.72cf7c72.png";